import { render } from "./RightButtom.vue?vue&type=template&id=60581b7b&scoped=true"
import script from "./RightButtom.vue?vue&type=script&lang=js"
export * from "./RightButtom.vue?vue&type=script&lang=js"

import "./RightButtom.vue?vue&type=style&index=0&id=60581b7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60581b7b"]])

export default __exports__